import { FaSuitcaseRolling, FaCalendarCheck, FaBug } from 'react-icons/fa';
import { MdPaid } from 'react-icons/md';
import { HiMiniBuildingOffice } from 'react-icons/hi2';
import { FcPaid } from 'react-icons/fc';
import Wrapper from '../assets/wrappers/StatsContainer';
import StatItem from './StatItem';

const StatsContainer = ({ defaultStats }) => {
  const stats = [
    {
      title: 'כל הבניינים',
      count: defaultStats?.allBuildings || 0,
      icon: <HiMiniBuildingOffice />,
      color: '#f59e0b',
      bcg: '#fef3c7',
    },
    {
      title: 'בניינים בתשלום',
      count: defaultStats?.paidMembers || 0,
      icon: <MdPaid />,
      color: '#ef4444',
      bcg: '#fee2e2',
    },
    {
      title: 'בניינים בחינם',
      count: defaultStats?.freeMembers || 0,
      icon: <FcPaid />,
      color: '#10b981',
      bcg: '#ccfbf1',
    },
  ];
  return (
    <Wrapper>
      {stats.map((item) => {
        return <StatItem key={item.title} {...item} />;
      })}
    </Wrapper>
  );
};

export default StatsContainer;
